export default "__VITE_ASSET__DXmKbvua__"